import { StyleSheet } from 'react-native';

import { COLORS } from '../../../styles/colors';

const borderWidth = 0;
export const styles = StyleSheet.create({
    page: {
        backgroundColor: COLORS.BACKGROUND_GRAY,
    },
    container: {
        borderWidth,
        padding: 10,
        paddingTop: 0,
        flex: 1,
        backgroundColor: COLORS.BACKGROUND_LIGHT_GRAY,
    },
    disabled: {
        opacity: 0.5,
    },
    selectorContainer: {
        margin: 12,
    },
    itemSection: {
        flexDirection: 'column',
        // flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        borderWidth,
        borderColor: 'yellow',
    },
    buttonsContainer: {
        flexDirection: 'row',
        paddingHorizontal: 10,
        paddingBottom: 10,
        backgroundColor: 'white',
        borderTopWidth: 1,
        borderColor: COLORS.BORDER_GRAY,
    },
    saveButton: {
        flex: 1,
    },
    cancelButton: {
        flex: 1,
        backgroundColor: 'white',
        marginRight: 10,
        color: 'black',
        textColor: 'black',
    },
    saveButtonTitle: {
        color: 'white',
    },
    cancelButtonTitle: {
        color: COLORS.STANDARD_GRAY,
    },
    checkboxContainer: {
        paddingVertical: 16,
        paddingHorizontal: 14,
        backgroundColor: 'white',
        borderColor: COLORS.BORDER_GRAY,
        borderWidth: 1,
    },
    checkboxContainerFirst: {
        borderBottomWidth: 0,
    },
    checkbox: {
        paddingHorizontal: 0,
        marginLeft: 0,
        paddingLeft: 0,
        borderWidth: 0,
    },
    sectionStyle: {
        paddingHorizontal: 0,
        borderWidth: 0,
    },
    firstSectionStyle: {
        marginTop: 0,
        marginBottom: 0,
        paddingHorizontal: 0,
        borderWidth: 0,
    },
    secondSectionStyle: {
        marginTop: 12,
        marginBottom: 0,
        paddingHorizontal: 0,
        borderWidth: 0,
    },
    image: {
        width: 32,
        height: 32,
    },
    pageContainer: {
        flex: 1,
        flexDirection: 'col',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth,
        borderColor: 'red',
    },
    header: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
    titleContainer: {
        // flex: 1,
        flexDirection: 'col',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth,
    },
    operationContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderWidth,
        borderColor: 'blue',
    },
    buttonContainer: {
        // flex: 1,
        // flexDirection: 'row',
        // justifyContent: 'center',
        // alignItems: 'center',
        borderWidth,
        borderColor: 'green',
    },
    footer: {
        backgroundColor: 'white',
        padding: 16,
    },
    button: { margin: 16 },
    buttonTitle: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    listContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth,
    },
    listItem: {
        // flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        padding: 4,
        margin: 4,
        borderWidth,
    },
    listItemText: { padding: 4 },
});
